import { useEffect } from "react";
import { useState } from "react";


const useClock = (startTime) => {
    const [clock, setClock] = useState(startTime);
     useEffect(()=>{
        setTimeout(()=>{
            setClock(clock + 1);
            console.log(clock)
        },1000)
    },[clock])
return clock

};


export default useClock;